<template>
	<div>
		<form @submit.prevent="sendFormData" v-if="items">
			<div class="row">
				<div class="col-lg-6">
					<h3>I. rész: Információk az elvégzendő feladatról, a kockázatokról és a feladatot végzőkről</h3>
					<div class="form-group mt-2">
						<label class="form-label">1. Helyszín:</label>
						<input type="text" disabled v-model="form_data.location_name" class="form-control">
						<input type="text" class="form-control border-warning" v-model="form_data.location_name_extension" placeholder="kiegészítés...">
					</div>
					<div class="form-group mt-2">
						<label class="form-label">2. Munkafolyamat leírása:</label>
						<textarea cols="30" rows="10" class="form-control border-warning" v-model="form_data.description"></textarea>
						<label class="form-label mt-1">2.1 Kiegészítő információk:</label>
						<div class="d-block mt-2">{{ task.description }}</div>
					</div>
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th colspan="2">3. A munka megkezdése előtt a következőkről győződtem meg:</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, id) in items.before_work" :key="id">
									<td class="align-middle">
										<input type="checkbox" class="form-check-input border-warning"
											v-model="form_data.before_work[item.id]">
									</td>
									<td>
										{{ item.text }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>Neve</th>
									<th>Feladata</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(permit, id) in permit_type.permits" :key="id">
									<td>{{ permit.user_name }}</td>
									<td>{{ permit_local_roles ? permit_local_roles.find(p => p.id == permit.local_role).name
										: '' }}</td>
								</tr>
							</tbody>
						</table>
					</div>

				</div>
				<div class="col-lg-6">
					<h3>II. Rész: Az engedély hatályba léptetése, érvényessége</h3>
					<h5 class="mt-2">5. Engedély érvényesség</h5>
					<label class="form-label">Ez az engedély a következő dátumtól érvényes:</label>
					<div class="row">
						<div class="col-md-8">
							<div class="form-group mt-2">
								<input type="date" class="form-control border-warning" v-model="start_date" :min="now">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group mt-2">
								<input v-if="form_data.with_time" type="time" class="form-control border-warning"
									v-model="start_time">
							</div>
						</div>
					</div>
					<label class="form-label">Ez az engedély a következő dátumig érvényes:</label>
					<div class="row">
						<div class="col-md-8">
							<div class="form-group mt-2">
								<input type="date" class="form-control border-warning" v-model="end_date" :min="now">
							</div>
						</div>
						<div class="col-md-4">
							<div class="form-group mt-2">
								<input v-if="form_data.with_time" type="time" class="form-control border-warning"
									v-model="end_time">
							</div>
						</div>
					</div>
					<div class="form-check mt-2">
						<input class="form-check-input" :true-value="false" :false-value="true" type="checkbox"
							v-model="form_data.with_time" id="with_time_input" />
						<label class="form-check-label" for="with_time_input">Egész nap</label>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
import Task from "../../apis/Task";
import Location from "../../apis/Location";
import Confirmation from "../../apis/Confirmation";
import moment from 'moment';
export default {
	props: { permit_type: Object, task: Object },
	data() {
		return {
			form_data: {
				location_name: "",
				description: "",
				before_work: [false, false, false, false, false, false, false, false, false, false, false, false, false],
				end_date_time: null,
				start_date_time: null,
				with_time: false,
			},
			start_date: null,
			start_time: null,
			end_date: null,
			end_time: null,
			items: false,
			completition_items: false,
			permit_local_roles: false,
			now: moment().format('YYYY-MM-DD')
		}
	},
	computed: {
		is_complete() {
			if (this.completition_items.filter(ci => ci.satisfied == false).length == 0 && this.datetime_complete) {
				return true;
			} else {
				return false;
			}
		},
		datetime_complete() {
			if (this.start_date && this.end_date) {
				if (this.form_data.with_time) {
					if (this.start_time && this.end_time) {
						return true;
					} else {
						return false;
					}
				} else {
					return true;
				}
			} else {
				return false;
			}
		}
	},
	watch: {
		form_data: {
			handler() {
				this.completition_items.forEach(ci => {
					switch (ci.type) {
						case 1:
							if (this.form_data[ci.name].filter(i => i.value == true).length >= 1) {
								this.$set(ci, 'satisfied', true);
							} else {
								this.$set(ci, 'satisfied', false);
							}
							break;
						case 2:
							if (this.form_data[ci.name]) {
								this.$set(ci, 'satisfied', true);
							} else {
								this.$set(ci, 'satisfied', false);
							}
							break;
						case 3:
							if (this.form_data[ci.name].filter(i => i == false).length == 0) {
								this.$set(ci, 'satisfied', true);
							} else {
								this.$set(ci, 'satisfied', false);
							}
							break;
					}
				})
			},
			deep: true
		}
	},
	created() {
		if (this.permit_type.start_date_time) {
			let start_moment = moment(this.permit_type.start_date_time);
			this.start_date = start_moment.format('YYYY-MM-DD');
			this.start_time = start_moment.format('HH:mm');
		}
		if (this.permit_type.end_date_time) {
			let end_moment = moment(this.permit_type.end_date_time);
			this.end_date = end_moment.format('YYYY-MM-DD');
			this.end_time = end_moment.format('HH:mm');
		}
		Location.show(this.task.location_id)
			.then(response => {
				this.form_data.location_name = response.data.name;
			});
		if (this.permit_type.form_data) {
			this.form_data = this.permit_type.form_data;
		}
		this.permit_local_roles = JSON.parse(localStorage.getItem('constants')).permit_local_roles;
		this.items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).items;
		this.completition_items = JSON.parse(localStorage.getItem('constants')).permit_types.find(pt => pt.id == this.permit_type.permit_type).completition_items;
	},
	methods: {
		sendFormData() {
			if (!this.is_complete) {
				Confirmation.swalCustomConfirm("Hiányos kitöltés", "Mentés mindenképp", "Így az engedély nem lesz kitöltött állapotú, a mégsem gombra kattintva folytathatod a kitöltést")
					.then(response => {
						if (response.isConfirmed === true) {
							this.submitForm();
						} else {
							this.$emit('loadingstop');
						}
					});
			} else {
				this.submitForm();
			}
		},
		submitForm() {
			let start_date_time = this.start_date ? moment(this.start_date + ((this.start_time && this.form_data.with_time) ? ' ' + this.start_time : ' 00:00')).tz('Europe/Budapest').format() : this.start_date;
			let end_date_time = this.end_date ? moment(this.end_date + ((this.end_time && this.form_data.with_time) ? ' ' + this.end_time : ' 23:59')).tz('Europe/Budapest').format() : this.end_date;
			console.log(start_date_time);
			console.log(end_date_time);
			Task.sendPermitForm(this.task.id, this.permit_type.id, { form_data: this.form_data, is_complete: this.is_complete, start_date_time: start_date_time, end_date_time: end_date_time })
				.then(() => {
					this.$emit('closemodal', 'fill_detail_' + this.permit_type.id);
					this.$emit('iscomplete', this.is_complete);
					this.$emit('formdata', {
						form_data: this.form_data,
						start_date_time: start_date_time,
						end_date_time: end_date_time,
					});
				});
		}
	}
}
</script>